import { create } from 'zustand';
import { StorageValue, persist } from 'zustand/middleware';

export const INFO_STORE_KEY = 'info-store';

// TypeScript 인터페이스 정의
type InfoState = {
  accessToken: string;
  firstName: string;
  lastName: string;
  email: string;

  setInfo: (info: { accessToken: string; firstName: string; lastName: string; email: string }) => void;
  setFirstName: (firstName: string) => void;
  setLastName: (lastName: string) => void;
  setEmail: (email: string) => void;

  resetInfo: () => void;

  getInfo: () => { firstName: string; lastName: string; email: string };
};

// Zustand Store 생성
export const useInfoStore = create(
  persist<InfoState>(
    (set, get) => ({
      accessToken: '',
      firstName: '',
      lastName: '',
      email: '',

      setFirstName: (firstName) => set({ firstName }),
      setLastName: (lastName) => set({ lastName }),
      setEmail: (email) => set({ email }),
      setInfo: ({ accessToken, firstName, lastName, email }) => {
        return set({ accessToken, firstName, lastName, email });
      },

      resetInfo: () => {
        set({
          accessToken: '',
          firstName: '',
          lastName: '',
          email: '',
        });
      },

      getInfo: () => ({
        firstName: get().firstName,
        lastName: get().lastName,
        email: get().email,
      }),
    }),

    {
      name: INFO_STORE_KEY,
      storage: {
        getItem: (key): StorageValue<InfoState> | null => {
          const value = sessionStorage.getItem(key);
          return value ? JSON.parse(value) : null;
        },
        setItem: (key, value) => {
          sessionStorage.setItem(key, JSON.stringify(value));
        },
        removeItem: (key) => {
          sessionStorage.removeItem(key);
        },
      },
    },
  ),
);
